// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Error[data-v-4881ef0e]{background-color:var(--c-warm-gray);border:1px solid var(--c-light-gray);font-family:Open Sans,sans-serif;padding:20px}.Error ul[data-v-4881ef0e]{background-color:var(--c-error-lighten-15);margin:20px 0;padding:30px 30px 10px}.Error ul li[data-v-4881ef0e]{color:var(--c-error);list-style-type:none;margin:0 0 20px;padding:0}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
